import React, { useEffect, useState } from "react";
import Cookies from "js-cookie";

import { Button } from "@novaescola/eva-react-v2";

import { AccountApi } from "../../../api/account/account.api";

const COOKIE_NAME = "ane-confirmation-block_96e0eb2d4a";
const COOKIE_REMATRICULA_NAME = "ane-confirmation-block_bfef93f29c";
const COOKIE_CLOSE_NAME = "ane-confirmation-block_close";
const COMPONENTES_CURRICULARES = {
  PROFESSOR_REGENTE: { text: "Professor(a) Regente", id: "7f1ad38664" },
  POLIVALENTE: { text: "Polivalente (1º ao 5º ano)", id: "812ea73b29" },
  LINGUA_PORTUGUESA: { text: "Língua Portuguesa", id: "2rp9yjwjywv" },
  MATEMATICA: { text: "Matemática", id: "ymvjcoeblpc" },
  HISTORIA: { text: "História", id: "m1jwuhdl97" },
  GEOGRAFIA: { text: "Geografia", id: "05vnhzduxt3m" },
  CIENCIAS: { text: "Ciências", id: "3qy9gn3kaaf" },
  ARTE: { text: "Arte", id: "wptdk7p76q" },
  LINGUA_ESTRANGEIRA: { text: "Língua Estrangeira", id: "hfa0hn0ot5p" },
  QUIMICA: { text: "Química", id: "53d3bb8956" },
  FISICA: { text: "Física", id: "bed055882e" },
  BIOLOGIA: { text: "Biologia", id: "7a6e8dfa10" },
  EDUCACAO_FISICA: { text: "Educação Física", id: "hfa0hn0ot5p" },
  FILOSOFIA: { text: "Filosofia", id: "c0f50c8471" },
  SOCIOLOGIA: { text: "Sociologia", id: "a6845215f8" },
  ENSINO_RELIGIOSO: { text: "Ensino Religioso", id: "08efda5bc6" },
  OUTRO: { text: "Outro", id: "5ba3cea990" },
};

export const ConfirmationBlockComponenteCurricular = ({ user, fetchUser }) => {
  const [hidden, setHidden] = useState(true);
  const [componenteCurricular, setComponenteCurricular] = useState("");
  const [submitted, setSubmitted] = useState(false);
  const [accessToken, setAccessToken] = useState("");

  useEffect(() => {
    const token = Cookies.get("Bearer");

    setAccessToken(token);
    setHidden(false);

    if (user.disciplinas && user.disciplinas.length > 0)
      setComponenteCurricular(user.disciplinas[0].disciplinas);

    sendEventToDataLayer(
      "block_visualization",
      "JORNALISMO: matrícula - complementação de cadastro - componente - bloco visualizado"
    );
  }, []);

  const sendEventToDataLayer = (event, label) => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event, label });
  };

  const handleSubmit = async () => {
    setSubmitted(true);

    const response = await AccountApi.updateUserComponenteCurricular(
      accessToken,
      componenteCurricular
    );

    if (!response) {
      const expires = new Date();
      expires.setUTCDate(expires.getUTCDate() + 1);

      Cookies.set(COOKIE_CLOSE_NAME, "true", { expires });
      setHidden(true);

      return;
    }

    fetchUser(accessToken);

    const dtUltimaModificacao = new Date(user.dtUltimaModificacao);

    const lastYear = new Date();
    lastYear.setMonth(lastYear.getMonth() - 12);

    const finalEventLabel =
      user.disciplinas &&
      user.disciplinas.length > 0 &&
      (dtUltimaModificacao < lastYear || Cookies.get(COOKIE_REMATRICULA_NAME))
        ? " - rematrícula"
        : "";

    sendEventToDataLayer(
      "confirmation_block",
      `JORNALISMO: matrícula - complementação de cadastro - componente - botão enviar${finalEventLabel}`
    );
    sendEventToDataLayer(
      "confirmation_block",
      `JORNALISMO: matrícula - complementação de cadastro - componente - ${COMPONENTES_CURRICULARES[componenteCurricular].text}`
    );

    const expires = new Date();
    expires.setUTCFullYear(expires.getUTCFullYear() + 1);

    Cookies.set(
      `ane-confirmation-block_${COMPONENTES_CURRICULARES[componenteCurricular].id}`,
      "true",
      { expires }
    );
    Cookies.set(COOKIE_NAME, "true", { expires });
    setHidden(true);
  };

  const handleClose = () => {
    const expires = new Date();
    expires.setUTCDate(expires.getUTCDate() + 1);

    Cookies.set(COOKIE_CLOSE_NAME, "true", { expires });
    setHidden(true);

    sendEventToDataLayer(
      "confirmation_block",
      "JORNALISMO: matrícula - complementação de cadastro - componente - botão sair"
    );
  };

  if (hidden) return null;

  return (
    <div className="eva-bg-inst-50 eva-mb-07 eva-pr-05 eva-pl-05 eva-pb-05 eva-pt-05 confirmation-block">
      <div className="eva-mb-03 confirmation-block-title">
        <i className="far fa-circle-question eva-mr-03" />
        Em qual componente curricular você leciona?
      </div>
      <div className="confirmation-block-options-select">
        <label htmlFor="componente-curricular-select" className="eva-label">
          Componente Curricular *
        </label>
        <div className="eva-select-wrapper">
          <select
            id="componente-curricular-select"
            name="select"
            className="eva-select"
            value={componenteCurricular}
            onChange={(event) => setComponenteCurricular(event.target.value)}
          >
            <option disabled value="">
              Selecione uma opção
            </option>
            {Object.entries(COMPONENTES_CURRICULARES).map(
              ([value, { text }]) => (
                <option
                  value={value}
                  key={`componente-curricular-option-${text}`}
                >
                  {text}
                </option>
              )
            )}
          </select>
        </div>
      </div>
      <div className="eva-mt-05">
        <Button
          type="button"
          variant="primary"
          size="small"
          disabled={submitted || !componenteCurricular}
          onClick={handleSubmit}
        >
          Enviar
        </Button>
      </div>
      <button
        type="button"
        aria-label="Fechar"
        className="eva-cursor-pointer confirmation-block-close"
        onClick={() => handleClose()}
      >
        <i className="far fa-times"></i>
      </button>
    </div>
  );
};
